module.exports = __webpack_public_path__ + "img/17.de18b699.svg";